import React, { useContext } from 'react'
//import Checker from '../cmp/Checker' 
import Filter from '../cmp/Filter' 
//import RangeForm from '../cmp/RangeForm' 
import icon from '../icons.svg'

import {dataContext,localestr,toText,isValidDate,typeToText} from '../utils.js'

function RepSysLog({data=undefined,actions}){
    let wndData=''
    let content=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const context=useContext(dataContext)
    const loaddat=context.loaddata
    const msg=context.msg
    const inputRange=context.inputRange
    const OpenTabObject=context.OpenTabObject
    const setLoginData=context.setLoginData

    let from=new Date()
    from.setHours(0,0,0,0)
    let to=new Date()
    to.setHours(23,59,59,999)

    if (wndData.from) from=wndData.from
    if (wndData.to) to=wndData.to

    const acts={login:localestr('Вхід'),logoff:localestr('Вихід'),add:localestr('Створення'),mod:localestr('Зміна даних'),rem:localestr('Позначка на знищення'),
        rm1:localestr('Позначка на знищення'),rm0:localestr('Відміна позначки'),set:localestr('Зміна періодичних даних'),del:localestr('Видалення періодичних даних'),
        rgo:localestr('Зміна періодичних даних'),pst:localestr('Проведення'),ups:localestr('Відміна проведення'),clr:localestr('Остаточне видалення'),
        pr1:localestr('Друк замовлення'),pr2:localestr('Друк рахунку'),pr3:localestr('Друк чека'),brk:localestr('Розділення чека'),err:localestr('Помилка')}

    const filterData=[
        {caption:localestr('Користувач'),dataId:'user_id',typeVal:'catUsers'},
        {caption:localestr('Тип об\'єкта'),dataId:'type',typeVal:'selAllTypes'},
        {caption:localestr('Тип операції'),dataId:'action',typeVal:'selOperations'},
    ]

    
    function filterHandler(d){
        setWndData({...wndData,filter:d})
        //setSettings({repLiability:{from,to,grouping:d}})
    }

    function range(frm,to_){
        //let showRange=!wndData.showRange
        let froml=from
        let tol=to
        if (isValidDate(frm)) froml=frm
        if (isValidDate(to_)) tol=to_
        if (froml>tol) {
            msg(localestr('Не правильний діапазон дат'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        /*let Datal=table
        if (froml!==from || tol!==to) {
            Datal=undefined
        }*/
        /*setWndData({...wndData,showRange,from:froml,to:tol})
        if (!showRange) setSettings({repLiability:{from:froml,to:tol,grouping}})*/
        setWndData({...wndData,from:froml,to:tol})
        //setSettings({repLiability:{from:froml,to:tol}})
    }

    function getFolders(d){
        let ret=''
        if(!d) return ret
        ret=",'"+d.id+"'"
        if(d.data) d.data.forEach(el=>ret+=getFolders(el))
        return ret
    }

    function loadData(d){
        if(d){
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='UsrChoise') {setLoginData(d);return}
            //console.log(d)
            //let cols=[]//d.groups.map(el=>grouping.find(e=>e.value===el))
            const filters=d.filters.map(el=>el.caption)
            //console.log(cols)

            let data=[]
            //let keys=new Array(cols.length>1?cols.length-2:1)
            for(let i=0;i<d.data.length;i++){
                //const val=d.data[i]
                //const key=cols[cols.length-1]
                //let obj=null
                const item={date:new Date(d.data[i].date).toLocaleString(),action:acts[d.data[i].action]||d.data[i].action,object:typeToText(d.data[i].type)+' '+d.data[i].object,user:d.data[i].user,err:d.data[i].err,level:0}
                if(parseInt(d.data[i].object)&&d.data[i].object.length<10) item.obj={type:d.data[i].type,id:d.data[i].object}
                //if(key.type.substring(0,3)==='cat'||key.type.substring(0,3)==='fld') item.name=val[key.value.substring(0,key.value.length-2)+'n']||'...'
                /*if(key.type.substring(0,3)==='doc'&&val['doc_t']==='ignore') {item.name='ignore'}
                else if(key.type.substring(0,3)==='doc'&&val['doc_t']==='text') {item.name=localestr('Залишок')+' ('+new Date(val[key.value.substring(0,key.value.length-2)+'d']).toLocaleString()+')';item.type='text'}
                else if(key.type.substring(0,3)==='doc') item.name=typeToText(val['doc_t'])+' №'+val[key.value]+' ('+new Date(val[key.value.substring(0,key.value.length-2)+'d']).toLocaleString()+')'
                if(key.type.substring(0,3)==='sel') item.name=context.data[key.type].find(e=>e.value===val[key.value]).name
                if(key.type.substring(0,3)==='doc'&&val['doc_t']!=='text') obj={type:val['doc_t'],id:item.id}
                else if((key.type.substring(0,3)==='cat'||key.type.substring(0,3)==='doc')&&val['doc_t']!=='text'&&item.id) obj={type:key.type,id:item.id}*/
                //item.obj=obj
                data.push(item)
                //if(key.type.substring(0,3)==='doc'&&val['doc_t']!=='text'&&val['doc_t']!=='ignore') continue
            }
            const caption=localestr('Історія дій за період ')+new Date(d.from).toLocaleDateString()+' - '+new Date(d.to).toLocaleDateString()+''
            console.log(data)
            setWndData({...wndData,content:{caption,filters,data}})

        } else {
            let froml=from.toISOString().substring(0,19)+'Z'
            let tol=to.toISOString().substring(0,19)+'Z'
            let tz=to.getTimezoneOffset()
            if(tz<0) tz='%2B0'+(tz/-60)+':00'
            else  tz='-0'+(tz/60)+':00'
            //for(let i=0;i<1;i++) if(grouping[i].checked) groups.push(grouping[i].value)
            let filters=[]
            if(wndData.filter){
                filters=wndData.filter.filter(el=>el.compare)
                for(let i=0;i<filters.length;i++){
                    let new_el={value:filters[i].dataId}
                    if(filters[i].compare==='='||filters[i].compare==='>'||filters[i].compare==='<'){
                        if(!filters[i].value) new_el.compare=' IS NULL'
                        else if(filters[i].value.id) new_el.compare=''+filters[i].compare+"'"+filters[i].value.id+"'"
                        else new_el.compare=''+filters[i].compare+"'"+filters[i].value+"'"
                        new_el.caption=filters[i].caption+' '+filters[i].compare+' '+toText(filters[i].value)
                    } if(filters[i].compare==='<>'){
                        if(!filters[i].value) new_el.compare=' IS NOT NULL'
                        else if(filters[i].value.id) new_el.compare="!='"+filters[i].value.id+"'"
                        else new_el.compare=''+filters[i].compare+"'"+filters[i].value+"'"
                        new_el.caption=filters[i].caption+' '+filters[i].compare+' '+toText(filters[i].value)
                    } else if(filters[i].compare==='lk') {
                        new_el.compare="LIKE('%"+filters[i].value+"%')"
                        new_el.caption=filters[i].caption+' '+localestr('містить')+' '+toText(filters[i].value)
                    }
                    else if(filters[i].compare==='nlk') {
                        new_el.compare="NOT LIKE('%"+filters[i].value+"%')"
                        new_el.caption=filters[i].caption+' '+localestr('не містить')+' '+toText(filters[i].value)
                    }
                    else if(filters[i].compare==='in_f') {
                        new_el.value=filters[i].dataId+'p'
                        new_el.compare='IN('+getFolders(filters[i].value).substring(1)+')'
                        new_el.caption=filters[i].caption+' '+localestr('в папці')+' '+toText(filters[i].value)
                    }else if(filters[i].compare==='nin_f') {
                        new_el.value=filters[i].dataId+'p'
                        new_el.compare='NOT IN('+getFolders(filters[i].value).substring(1)+')'
                        new_el.caption=filters[i].caption+' '+localestr('не в папці')+' '+toText(filters[i].value)
                    }
                    filters[i]=new_el
                }
            }
            loaddat('action=repUsrHistory&data='+JSON.stringify({from:froml,to:tol,tz,filters}),null,(dt)=>{loadData(dt)})
        }
    }

    function specification(obj){
        if(!obj) return
        //console.log(obj)
        OpenTabObject(obj.type,obj.id)
    }

    if(wndData.content){
        let filters=null
        if(wndData.content.filters.length){
            filters=wndData.content.filters.map((el,idx)=>{
                return <p key={idx}>{el}</p>
            })
            filters=<div className='rep_filters'>{filters}</div>
        }
        const items=wndData.content.data.map((el,idx)=>{
            let fn=()=>{}
            if(el.obj) fn=()=>specification(el.obj)
            if(el.err){
                return <tr tabIndex='0' key={idx} onDoubleClick={fn}>
                <td className={'rep_grp'+el.level}>{el.date}</td>
                <td style={{backgroundColor:['#FFC8C8']}} className={'rep_grp'+el.level}>{el.action}</td>
                <td style={{backgroundColor:['#FFC8C8']}} className={'rep_grp'+el.level}>{el.object}</td>
                <td className={'rep_grp'+el.level}>{el.user}</td>
            </tr>
            }

            return <tr tabIndex='0' key={idx} onDoubleClick={fn}>
                <td className={'rep_grp'+el.level}>{el.date}</td>
                <td className={'rep_grp'+el.level}>{el.action}</td>
                <td className={'rep_grp'+el.level}>{el.object}</td>
                <td className={'rep_grp'+el.level}>{el.user}</td>
            </tr>


            /*const sum_s=el.sum_s?el.sum_s.toFixed(2):''
            const sum_d=el.sum_d?el.sum_d.toFixed(2):''
            const sum_c=el.sum_c?el.sum_c.toFixed(2):''
            let sum_f=(el.sum_s+el.sum_d-el.sum_c)?(el.sum_s+el.sum_d-el.sum_c).toFixed(2):''
            if(el.type==='document') sum_f=''
            if(el.obj) return <tr tabIndex='0' key={idx}><td style={{cursor:'pointer'}} className={'rep_grp'+el.level} onDoubleClick={()=>specification(el.obj)}>{el.name}</td><td className={'rep_grp'+el.level+' rep_number'+(el.sum_s<0?' red':'')}>{sum_s}</td><td className={'rep_grp'+el.level+' rep_number'+(el.sum_d<0?' red':'')}>{sum_d}</td><td className={'rep_grp'+el.level+' rep_number'+(el.sum_c<0?' red':'')}>{sum_c}</td><td className={'rep_grp'+el.level+' rep_number'+(sum_f<0?' red':'')}>{sum_f}</td></tr>
            else return <tr tabIndex='0' key={idx}><td className={'rep_grp'+el.level}>{el.name}</td><td className={'rep_grp'+el.level+' rep_number'+(el.sum_s<0?' red':'')}>{sum_s}</td><td className={'rep_grp'+el.level+' rep_number'+(el.sum_d<0?' red':'')}>{sum_d}</td><td className={'rep_grp'+el.level+' rep_number'+(el.sum_c<0?' red':'')}>{sum_c}</td><td className={'rep_grp'+el.level+' rep_number'+(sum_f<0?' red':'')}>{sum_f}</td></tr>
            */
        })
        content=<><h3 className='rep_caption'>{wndData.content.caption}</h3>{filters}
        <table className='rep_table'>
            <thead><tr>
                <th>{localestr('Дата')}</th>
                <th>{localestr('Дія')}</th>
                <th>{localestr('Інформація')}</th>
                <th>{localestr('Користувач')}</th></tr></thead>
            <tbody>{items}</tbody>
        </table>
        </>
    }
    
    //const showRange = wndData.showRange ? <RangeForm from={from} to={to} setRng={range}/> : ''  //+

    return(
        <div style={{width:'100%', height:'100%', display:'flex', flexDirection:'row'}}>
            <div style={{width:'100%', height:'100%', display:'flex', flexDirection:'column'}}>
                <div className='toolBar no-print'>
                    <div tabIndex='0' onClick={()=>{loadData()}} onKeyUp={(e)=>{if(e.key === 'Enter') loadData()}}
                        style={{alignSelf:'center',lineHeight:'30px',height:'30px',width:'95px',padding:'0px 2px 0 6px',color:'#FFF',userSelect:'none',cursor:'pointer',background:'url('+icon+'#btn95v) no-repeat',backgroundSize:'102px 30px'}}>
                        <img style={{width:'12px',height:'24px',padding:'2px',verticalAlign:'middle'}} src={icon+'#run'} alt={localestr('Вивести')} />&nbsp;
                        {localestr('Вивести')}
                    </div>
                    <div tabIndex='0' onClick={()=>{inputRange(from,to,range)}} onKeyUp={(e)=>{if(e.key === 'Enter') range()}}
                        style={{alignSelf:'center',lineHeight:'30px',height:'30px',width:'192px',padding:'0px 2px 0 6px',userSelect:'none',cursor:'pointer',color:'#FFF',background:'url('+icon+'#btn185v) no-repeat',backgroundSize:'192px 30px'}}>
                        {toText(from)}-{toText(to)}
                        <img style={{width:'24px',height:'24px',verticalAlign:'middle'}} src={icon+'#cal_w'} alt={localestr('Інтервал дат')} />
                    </div>
                    <div style={{flexGrow:'10'}}></div>
                </div>
                <div className='reportContent'>{content}</div>
            </div>
            <div className='reportTuns no-print'>
                <Filter filterData={filterData} filter={wndData.filter} setFilter={filterHandler}/>
            </div>
            {/*showRange*/}
        </div>
    )

}


export default RepSysLog